import HttpServiceBasic from 'services/HttpServiceBasic';

export const IAMPendingStatus = 'pending';

export default class InAppMessagingTemp {
    constructor() {
        this.http = new HttpServiceBasic();
    }

    init() {
        if (this.isUserProfileOverlayOpen()) {
            return;
        }

        let pageLoadCount = parseInt(window.localStorage.getItem('cbsplc')) || 0; // page load count
        pageLoadCount++;

        if (pageLoadCount === 2 && !CBS.Registry.intlOverlay) {
            const params = {
                pageType: CBS.Registry.pageType,
                timestamp: new Date().getTime(),
                availableForProfileTypesOnShows: CBS.Registry.Show.availableForProfileTypesOnShows,
                availableForProfileTypesOnMovies: CBS.Registry.availableForProfileTypesOnMovies,
            };

            if (CBS.Registry.IAM && CBS.Registry.IAM !== '') {
                return;
            } else {
                CBS.Registry.IAM = IAMPendingStatus;
            }

            return this.http
                .doGet('/in-app-messaging/', params)
                .then((resp) => {
                    if (resp) {
                        import('shared/popup/GlobalPopup.js')
                            .then((module) => {
                                CBS.Registry.IAM = window.location.pathname;
                                new module.default(resp);
                            })
                            .catch((error) => {});
                    }
                })
                .catch(() => {
                    if (CBS.Registry.IAM) {
                        delete CBS.Registry.IAM;
                    }
                });
        }

        window.localStorage.setItem('cbsplc', pageLoadCount.toString());
    }

    isUserProfileOverlayOpen() {
        if (document.querySelector('#user-profiles-js-var')) {
            const userProfileCmds = JSON.parse(
                document.querySelector('#user-profiles-js-var').innerHTML,
            );
            if (userProfileCmds.startupCmds && userProfileCmds.startupCmds.length > 0) {
                let isUserProfileOverlayOpen = userProfileCmds.startupCmds.find(
                    (cmd) =>
                        cmd.hasOwnProperty('cmd_show_overlay') && cmd.cmd_show_overlay === true,
                );

                return typeof isUserProfileOverlayOpen !== 'undefined';
            }
        }

        return false;
    }
}
